export class LeadSource {
  public id: string;
  public leadSourceId: string;
  public sourceDetailId: string;
  public referralSourceId: string;

  public leadSource: string;
  public sourceDetail: string;
  public referralSource: string;

  public displayName: string;
  public displayCode: string;

  public isParent: boolean;
  public parentId: string; // this is id of its parent; a parent client should have parentId = 0

  constructor(
    id: string,
    leadSourceId: string,
    sourceDetailId: string,
    referralSourceId: string,
    leadSource: string,
    sourceDetail: string,
    referralSource: string,
    displayName: string,
    displayCode: string,
    parentId: string,
    isParent: boolean,
  ) {
    this.id = id;
    this.leadSourceId = leadSourceId;
    this.sourceDetailId = sourceDetailId;
    this.referralSourceId = referralSourceId;
    this.leadSource = leadSource;
    this.sourceDetail = sourceDetail;
    this.referralSource = referralSource;
    this.displayName = displayName;
    this.displayCode = displayCode;
    this.parentId = parentId;
    this.isParent = isParent;
  }
}
